import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=baa9485c&scoped=true&"
import script from "./agree.vue?vue&type=script&lang=ts&"
export * from "./agree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9485c",
  null
  
)

export default component.exports